import React, { PropsWithChildren } from "react";
import { Overlayer } from "uikit";

import Overlay from "./components/Overlay";

const Loader: React.FC<Loader.Props> = ({
	active = false,
	dimmed = true,
	lightDimmed = false,
	withText = false,
	children,
}) =>
	// eslint-disable-next-line no-nested-ternary
	children ? (
		<Overlayer
			style={{ width: "100%", height: "100%" }}
			overlay={
				active ? (
					<Overlay
						dimmed={dimmed}
						lightDimmed={lightDimmed}
						maxedSize
						withText={withText}
					/>
				) : null
			}
		>
			{children}
		</Overlayer>
	) : active ? (
		<Overlay
			dimmed={dimmed}
			lightDimmed={lightDimmed}
			maxedSize={false}
			withText={withText}
		/>
	) : null;

declare namespace Loader {
	interface Props extends PropsWithChildren {
		active?: boolean;
		dimmed?: boolean;
		lightDimmed?: boolean;
		withText?: boolean;
	}
}

export default Loader;
